import axios from 'axios'
axios.defaults.headers.common = {
  'X-Requested-With': 'XMLHttpRequest',
}

const sessionCheck = () => {
  axios.get("./php/setStartSettings.php")
}

const accessBannedCheck = async() => {
  return new Promise((resolve) => {
    // アクセス禁止チェック
    axios.get("./php/isAccessBanned.php")
      .then((response) => { resolve(response.data) })
  })
}

const adBlockCheck = async() => {
  return new Promise((resolve) => {
    // 広告ブロックのチェック
    fetch("https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js", {
      method: "HEAD",
      mode: "no-cors",
      cache: "no-store"
    })
    .then(async() => {
      await fetch("https://j.microad.net/js/compass.js", {
        method: "HEAD",
        mode: "no-cors",
        cache: "no-store"
      })
      .then(() => { resolve(false) })
      .catch(() => { resolve(true) })
    })
    .catch(() => { resolve(true) })
  })
}

const useBraveCheck = () => {
 // ブラウザチェック
  const brave_flg = navigator.brave && navigator.brave.isBrave();
  if (typeof brave_flg !== "undefined") {
    return true
  } else {
    return false
  }
}

export { sessionCheck, accessBannedCheck, adBlockCheck, useBraveCheck }